import { Checkbox, DynamicInput, FormLabel, Textinput } from "shared";
import {
    ITemplateComponent,
    ITemplateSaveToExistingTicketComponent
} from "entities/template";
import React from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import { VisibilityField } from "../../form_fields/visibility_field/visibility_field";
import { TooltipField } from "../../form_fields/tooltip_field/tooltip_field";
import { LabelField } from "../../form_fields/label_field/label_field";
import styles from "./component_form_save_to_existing_ticket.module.scss";
import { useComponentValidateFunction } from "../../../../lib/hooks/useComponentValidateFunction";

interface IComponentFormSaveToExistingTicketProps {
    component: ITemplateSaveToExistingTicketComponent;
    componentList: ITemplateComponent[];
    enLanguageEnabled: boolean;
    onChange: (component: ITemplateComponent) => void;
    triggerValidate: number;

}

export const ComponentFormSaveToExistingTicket: React.FC<IComponentFormSaveToExistingTicketProps> = React.memo(({
                                                                                                                    component,
                                                                                                                    componentList,
                                                                                                                    triggerValidate,
                                                                                                                    enLanguageEnabled,
                                                                                                                    onChange
                                                                                                                }) => {
    const t = useComponentsTranslations();
    const { requiredFieldValidation } = useComponentValidateFunction();

    const onFieldChange = (value: Partial<ITemplateSaveToExistingTicketComponent>) => {
        onChange({
            ...component,
            ...value
        })
    }

    return <div className={styles.container}>
        <LabelField component={component}
                    enLanguageEnabled={enLanguageEnabled}
                    title={t("name")}
                    name="name-dynamic-input"
                    onChange={onFieldChange}/>
        <FormLabel title={t("trackerQueue")} required={true}>
            <Textinput size="m"
                       value={component.startrekQueueAttach ? component.startrekQueueAttach : ""}
                       triggerValidate={triggerValidate}
                       validate={true}
                       validateFunc={requiredFieldValidation}
                       onChange={(e) => onFieldChange({ startrekQueueAttach: e.target.value })}
                       view="outline"/>
            <div className={styles.subLabel}>{"* " + t("existingTrackerQueueDescription")}</div>
        </FormLabel>
        <FormLabel title={t("commentForTracker")}>
            <DynamicInput size="m"
                          textareaEdge={70}
                          name="startrekCommentTemplate"
                          value={component.startrekCommentTemplate ? component.startrekCommentTemplate : ""}
                          onChange={(e: any) => onFieldChange({ startrekCommentTemplate: e.target.value })}
                          view="outline"/>
        </FormLabel>
        {enLanguageEnabled && <FormLabel title={t("commentForTracker") + " [En]"}>
            <DynamicInput size="m"
                          textareaEdge={70}
                          name="startrekCommentTemplate_en"
                          value={component.startrekCommentTemplate_en ? component.startrekCommentTemplate_en : ""}
                          onChange={(e: any) => onFieldChange({ startrekCommentTemplate_en: e.target.value })}
                          view="outline"/>
        </FormLabel>}
        <FormLabel title={t("formTag")} required={true}>
            <Textinput size="m"
                       value={component.name}
                       disabled={true}
                       view="outline"/>
        </FormLabel>
        <VisibilityField
            component={component}
            componentList={componentList}
            onChange={onFieldChange}/>
        <TooltipField
            component={component}
            enLanguageEnabled={enLanguageEnabled}
            onChange={onFieldChange}
        />
        <div className={styles.checkboxGroup}>
            <Checkbox
                className={styles.firstCheckbox}
                label="PDF"
                size="m"
                onChange={() => onFieldChange({ isDocPdf: component.isDocPdf === false })}
                checked={component.isDocPdf !== false}
            />
            <Checkbox
                label="Word"
                size="m"
                onChange={() => onFieldChange({ isDocRtf: component.isDocRtf === false })}
                checked={component.isDocRtf !== false}
            />
        </div>
        <div className={styles.checkboxGroup}>
            <Checkbox
                className={styles.firstCheckbox}
                label={t("pdfUnprotected")}
                size="m"
                onChange={() => onFieldChange({ isDocPdfNopass: !component.isDocPdfNopass })}
                checked={!!component.isDocPdfNopass}
            />
            <Checkbox
                label={t("documentUnprotected")}
                size="m"
                onChange={() => onFieldChange({ isDocRtfNopass: !component.isDocRtfNopass })}
                checked={!!component.isDocRtfNopass}
            />
        </div>
        <div className={styles.description}>{t("saveToExistingTicketComponentDescription")}</div>
        <Checkbox
            label={t("attachFileToTicket")}
            size="m"
            onChange={() => onFieldChange({ isUploadFile: !component.isUploadFile })}
            checked={!!component.isUploadFile}
        />
        <Checkbox
            label={t("showTicketNumberAndComment") + " *"}
            size="m"
            onChange={() => onFieldChange({ isFullView: component.isFullView === false })}
            checked={component.isFullView !== false}
        />
        <div className={styles.showTicketNumberAndCommentContainer}>
            <div className={styles.descriptionLine}>{"* " + t("showTicketNumberDesc1")}</div>
            <div className={styles.descriptionLine}>{t("showTicketNumberDesc2")}</div>
            <div className={styles.descriptionLine}>{t("showTicketNumberDesc3")}</div>
            <div className={styles.descriptionLine}>{t("showTicketNumberDesc4")}</div>
        </div>
    </div>
});
